import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Notification } from '@app/modules/smart-devices/service/smart-devices.service';
import { SmartNotificationsService } from '@app/modules/smart-devices/service/smart-notifications.service';
import { OptimizelyService } from '@app/shared/services/optimizely/optimizely.service';
import { interval } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-smart-device-notifications',
  templateUrl: 'smart-device-notifications.component.html',
  styleUrls: ['./smart-device-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartDeviceNotificationsComponent {
  constructor(
    private smartNotifications: SmartNotificationsService,
    private optimizely: OptimizelyService
  ) {
    this.smartNotifications.fetchNotificationsFromApi();
  }

  notificationState$ = this.smartNotifications.notifications$;

  intervalSubscription = interval(60_000).subscribe(() => {
    console.log('Fetching notifications');
    this.smartNotifications.pollForNewNotifications();
  });

  trackNotificationsByFn(index: number, notification: Notification) {
    return notification.id;
  }

  onNearEndScroll(cursor: string) {
    if (cursor) {
      this.smartNotifications.fetchNotificationsFromApi(cursor);
    }
  }

  markNotificationAsRead(id: Notification['id']) {
    this.smartNotifications.markNotificationAsRead(id);

    // if state has a next cursor, and we don't have a scrollbar
    this.notificationState$
      .pipe(
        take(1),
        map((state) => state.meta.next_cursor)
      )
      .subscribe((cursor) => {
        if (cursor) {
          this.smartNotifications.fetchNotificationsFromApi(cursor);
        }
      });
  }
}
